//npm packages
import React, { useEffect, useCallback, memo, useState } from 'react';
import { connect, useSelector, shallowEqual } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import {
  login,
  resetPassword,
  resetPasswordReq,
  resetPasswordReqReset,
  resetPasswordReset
} from '../../redux/actions';
import strings from '../../globalization';
import { Container, Col, Form, Row, Button } from 'reactstrap';

import './login.css';
import { InputField, Validator } from '../../components';

const defaultLoginType = {
    showLogin: false,
    showForgotPassword: false,
    showResetPassword: false
  },
  defaultValues = {},
  // {
  //   UserName: 'superadmin',
  //   Password: 'steris@cat'
  // }
  resetForm = {
    UserName: '',
    Password: ''
  },
  textStyle = {
    color: 'dark',
    textAlign: 'center',
    paddingTop: '1em',
    textDecoration: 'underline',
    cursor: 'pointer',
    width: 'min-content',
    margin: 'auto',
    whiteSpace: 'nowrap',
    userSelect: 'none'
  };

const Login = memo(props => {
  const {
    handleSubmit,
    pristine,
    submitting,
    loginData,
    dispatch,
    history,
    resetPasswordData,
    resetPasswordReqData
  } = props;
  const [loginType, setLoginType] = useState({
    showLogin: true,
    showForgotPassword: false,
    showResetPassword: false
  });

  const onPasswordChangeRequest = () => {
    setLoginType({ ...defaultLoginType, showForgotPassword: true });
    props.initialize(resetForm);
  };
  const onLoginSwitch = () => {
    setLoginType({ ...defaultLoginType, showLogin: true });
    props.initialize(defaultValues);
  };

  const onPasswordChange = () => {
    setLoginType({ ...defaultLoginType, showResetPassword: true });
  };

  const onSubmit = useCallback(values => {
    dispatch(login(values));
  }, []);

  const onResetPasswordReq = useCallback(values => {
    delete values.confirmPassword;
    dispatch(resetPasswordReq(values));
  }, []);

  const onResetPassword = useCallback(values => {
    delete values.confirmPassword;
    dispatch(resetPassword(values));
  }, []);

  const data = useSelector(state => {
    return { loginData: state.loginData };
  }, shallowEqual);

  useEffect(() => {
    dispatch(login(null, { apiMethod: 'GET', isFromLoginPage: true }));
  }, []);

  useEffect(() => {
    const { success = false } = loginData.data || {};
    if (success) {
      history.push({ pathname: '/managelicense' });
    }
  }, [loginData.data]);

  useEffect(() => {
    const { success } = resetPasswordData.data || {};
    if (success) {
      onLoginSwitch();
      dispatch(resetPasswordReset());
    }
  }, [resetPasswordData.data]);

  useEffect(() => {
    const { success } = resetPasswordReqData.data || {};
    if (success) {
      onPasswordChange();
      dispatch(resetPasswordReqReset());
    }
  }, [resetPasswordReqData.data]);

  return (
    <Container className="login is-responsive">
      <div>
        <div className="split left"></div>
        <div className="split right">
          <div className="rightFlipBackground"></div>
        </div>
        <div className="centered">
          <div className="leftFlip">
            <center>
              <div className="leftFlip_Center_div text-white">
                <span>
                  <u style={{ textUnderlinePosition: 'under' }}>
                    <b>{strings.Welcome}</b>
                  </u>
                </span>
                <br />
                <div>
                  <p className="about_License_Text">CAT License App</p>
                </div>
              </div>
            </center>
          </div>
          <div
            className="rightFlip"
            style={loginType.showResetPassword ? { overflow: 'auto' } : {}}
          >
            <center>
              <div className="signIn">
                <img src="./img/logologin.png" alt="" />
                <br />
                <br />
              </div>
              {loginType.showLogin ? (
                <Form className="loginbox" onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Field
                        name="UserName"
                        type="input"
                        component={InputField}
                        placeholder="Username"
                        validate={Validator.required}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Field
                        name="Password"
                        type="password"
                        component={InputField}
                        placeholder="Password"
                        validate={Validator.required}
                        autoComplete="on"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Button
                        type="submit"
                        color="success"
                        disabled={submitting}
                        block
                      >
                        {strings.Login}
                      </Button>
                    </Col>
                  </Row>
                  <p onClick={onPasswordChangeRequest} style={textStyle}>
                    Forgot Password
                  </p>
                  <p className="m-t copyright_color">
                    {' '}
                    <small>
                      {strings.Copyright} &copy; {strings.SterisCorporation}{' '}
                      {new Date().getFullYear()}
                    </small>
                  </p>
                </Form>
              ) : loginType.showForgotPassword ? (
                <Form
                  className="loginbox"
                  onSubmit={handleSubmit(onResetPasswordReq)}
                >
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Field
                        name="UserName"
                        type="input"
                        component={InputField}
                        placeholder="Username"
                        validate={Validator.required}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Field
                        name="EmailAddress"
                        type="input"
                        component={InputField}
                        placeholder="Email Address"
                        validate={[Validator.required, Validator.email]}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Button
                        type="submit"
                        color="success"
                        disabled={pristine || submitting}
                        block
                      >
                        {strings.ResetPassword}
                      </Button>
                    </Col>
                  </Row>
                  <p onClick={onLoginSwitch} style={textStyle}>
                    Switch to login
                  </p>
                  <p className="m-t copyright_color">
                    {' '}
                    <small>
                      {strings.Copyright} &copy; {strings.SterisCorporation}{' '}
                      {new Date().getFullYear()}
                    </small>
                  </p>
                </Form>
              ) : loginType.showResetPassword ? (
                <Form
                  className="loginbox"
                  onSubmit={handleSubmit(onResetPassword)}
                >
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Field
                        name="NewPassword"
                        type="password"
                        component={InputField}
                        placeholder="New Password"
                        validate={[
                          Validator.required,
                          Validator.passwordStrength
                        ]}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Field
                        name="ConfirmPassword"
                        type="password"
                        component={InputField}
                        placeholder="Confirm Password"
                        validate={[
                          Validator.required,
                          Validator.passwordStrength,
                          Validator.confirmPassword
                        ]}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" md="12" className="mb-2 login_input_type">
                      <Button
                        type="submit"
                        color="success"
                        disabled={pristine || submitting}
                        block
                      >
                        {strings.Submit}
                      </Button>
                    </Col>
                  </Row>
                  <p onClick={onLoginSwitch} style={textStyle}>
                    Switch to login
                  </p>
                  <p className="m-t copyright_color">
                    {' '}
                    <small>
                      {strings.Copyright} &copy; {strings.SterisCorporation}{' '}
                      {new Date().getFullYear()}
                    </small>
                  </p>
                </Form>
              ) : (
                ''
              )}
            </center>
          </div>
        </div>
      </div>
    </Container>
  );
});

const LoginRedux = reduxForm({
  form: 'login',
  enableReinitialize: false
})(Login);

const mapStateToProps = state => ({
  initialValues: defaultValues,
  loginData: state.loginData,
  resetPasswordData: state.resetPasswordData,
  resetPasswordReqData: state.resetPasswordReqData
});

const LoginModule = connect(mapStateToProps)(LoginRedux);

export default LoginModule;
